export function roundCoordinate(n: number, p = 5) {
  return (e => Math.round(n * e) / e)(Math.pow(10, p))
}
